import cn from "../languages/cn";
import "../styles/loading.scss";
import { trackPrivacyLeave } from "../webar-core/framework/utils/gtag";
/**
 * This Component shows an age gate that dictates whether or not should the user proceed with the experience
 * @param props
 * @returns
 */
export const PrivacyPolicyComponent = (props: any) => {
  return (
    <div
      id="privacyPolicyPopUp"
      className={`${props.showPrivacyPolicy ? "animateIn" : ""}`}
    >
      <div
        className="privacyPolicyTitle"
        id="privacyPolicyTitle"
        dangerouslySetInnerHTML={{
          __html: props.translate
            ? cn.privacyPolicyTitle.text
            : "Are you sure you want <br/> to leave this experience?",
        }}
      ></div>
      <div className="buttonsWrapper">
        <a
          id="privacyLeaveButton"
          className="leaveButton"
          href="https://rockpaperreality.com/privacy-policy/"
          onClick={() => {
            trackPrivacyLeave();
          }}
        >
          <span>{props.translate ? cn.ageGateSpanYes.text : "Leave"}</span>
        </a>
        <div
          className="stayButton"
          id="stayButton"
          onClick={() => {
            props.setPrivacyStay(true);
          }}
        >
          <img
            className="highlight"
            src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/loadingPage/gradientSwipe.png"
            alt=""
          />
          <span>{props.translate ? cn.ageGateSpanNo.text : "Stay"}</span>
        </div>
      </div>
    </div>
  );
};
